import { render, staticRenderFns } from "./UIDialogDelete.vue?vue&type=template&id=70786496&scoped=true&"
import script from "./UIDialogDelete.vue?vue&type=script&lang=js&"
export * from "./UIDialogDelete.vue?vue&type=script&lang=js&"
import style0 from "./UIDialogDelete.vue?vue&type=style&index=0&id=70786496&prod&scoped=true&lang=css&"
import style1 from "./UIDialogDelete.vue?vue&type=style&index=1&id=70786496&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70786496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog})
